import ConfirmNavigate from "./ConfirmNavigate";
import * as ReactDOM from "react-dom";
import * as React from "react";
import {theme} from "colors";
import Theme from "components/Theme";
import store from "../../store";
import { FormPaperLayoutReducerState } from "../FormPaperLayout/reducers";

const getUserConfirmation = (message: any, callback: any) => {
    const app = document.getElementById("app");
    const modal = document.createElement("div");
    app.appendChild(modal);

    // The name need to be the same as formPaperLayoutReducer in ../FormPaperLayout/reducers.ts, would be nice if we have nameOf
    const formPaperLayoutState: FormPaperLayoutReducerState = store.getState()["formPaperLayoutReducer"];
    const withCleanup = (answer: any) => {
        callback(answer);
        setTimeout(() => {
            // Give the close animation time to do its thing.
            ReactDOM.unmountComponentAtNode(modal);
            app.removeChild(modal);
        }, 500);
    };

    ReactDOM.render(
        // We HAVE to explicitly set the theme here or this doesn't work.
        <Theme theme={theme}>
            <ConfirmNavigate message={message} callback={withCleanup} onSaveClick={formPaperLayoutState.onSaveClick} />
        </Theme>
        , modal);
};

export default getUserConfirmation;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ConfirmNavigate/getUserConfirmation.tsx